<template>
  <v-container>
    <v-row align="center">
      <v-col md="5" offset-md="3">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="ui-module-titlebar justify-center font-weight-bold">Asignación de munición</v-card-title>
          <v-card-text>
            <v-container>
              <v-row align="center">
                <v-col cols="4" align="center">
                  <v-progress-circular
                    :value="activeStep * 33"
                    size="96"
                    width="12"
                    color="secondary"
                    rotate="-90"
                  ></v-progress-circular>
                </v-col>
                <v-col cols="8">
                  <div class="text-caption">
                    PASO {{ activeStep }}
                    <div v-if="activeStep == 3" class="d-inline">(Opcional)</div>
                  </div>
                  <div class="text-subtitle-1 font-weight-bold">{{ activeStepTitle }}</div>
                  <a class="text-decoration-none" v-show="activeStep != 1" v-on:click="activeStep--"
                    >Volver al paso anterior</a
                  >
                </v-col>
              </v-row>
            </v-container>
            <v-container>
              <v-row>
                <transition name="fade" mode="out-in">
                  <v-col md="12" v-if="activeStep == 1" key="1">
                    <v-select
                      class="ui-form-field"
                      v-model="municionCurso.fk_idCurso"
                      background-color="transparent"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="cursos"
                      item-value="id"
                      item-text="subcategoria"
                    >
                      <template v-slot:label>Seleccione un curso <span class="red--text">*</span> </template>
                    </v-select>
                  </v-col>
                  <v-col md="12" v-if="activeStep == 2" key="2">
                    <v-date-picker
                      v-model="municionCurso.fechaAsignado"
                      locale="es"
                      color="secondary"
                      :max="getMaxDay"
                      no-title
                      full-width
                    ></v-date-picker>
                  </v-col>
                  <v-col md="12" v-if="activeStep == 3" key="3">
                    <v-row>
                      <v-col cols="8" class="py-0">
                        <v-select
                          class="ui-form-field"
                          v-model="municionCurso.fk_idCatCalibre"
                          solo
                          filled
                          rounded
                          color="secondary"
                          background-color="transparent"
                          :items="calibres"
                          item-value="id"
                          item-text="title"
                          item-color="secondary"
                        >
                          <template v-slot:label>Seleccione calibre <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4" class="py-0">
                        <v-text-field
                          class="ui-form-field"
                          v-model.number="municionCurso.cantidad"
                          min="0"
                          background-color="transparent"
                          color="secondary"
                          type="number"
                          rounded
                          filled
                          dense
                        >
                          <template v-slot:label>Cantidad <span class="red--text">*</span> </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </transition>
              </v-row>
            </v-container>
            <v-container>
              <v-row>
                <v-col md="12" xl="6" offset-xl="3">
                  <v-btn
                    block
                    color="secondary"
                    class="ui-module-btn-solid"
                    v-on:click="activeStepButtonHandler"
                    :loading="loading"
                    :disabled="!validActiveStep || loading"
                    >{{ activeStepButtonLabel }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<style>
/* .card {
        box-shadow: 8px 8px 16px var(--v-primary-darken1), -8px -8px 16px var(--v-primary-lighten1) !important;
        transition: 0.3s;
    } */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.card-flat {
  box-shadow: none !important;
  transition: 0.3s;
}
</style>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  data() {
    return {
      activeStep: 1,
      loading: false,

      required: [(v) => !!v || 'Este campo es requerido.'],

      municionCurso: {
        fk_idCurso: null,
        fk_idCatCalibre: null,
        cantidad: 0,
        fechaAsignado: null,
      },
    }
  },

  computed: {
    ...mapGetters('curso', {
      cursos: 'getCursos',
    }),

    ...mapGetters('calibre', {
      calibres: 'getCalibres',
    }),

    getMaxDay: function () {
      return moment().format(this.VUETIFY_DATE_FORMAT)
    },

    activeStepTitle: function () {
      switch (this.activeStep) {
        case 1:
          return 'Elegir Curso'
        case 2:
          return 'Fecha de asignación'
        case 3:
          return 'Información de asignación'
      }
    },

    validActiveStep: function () {
      switch (this.activeStep) {
        case 1:
          if (this.municionCurso.fk_idCurso) {
            return true
          } else return false
        case 2:
          if (this.municionCurso.fechaAsignado) {
            return true
          } else return false
        case 3:
          if (this.municionCurso.cantidad > 0 && this.municionCurso.fk_idCatCalibre) {
            return true
          } else return false
      }
    },

    activeStepButtonLabel: function () {
      if (this.activeStep < 3) {
        return 'Siguiente paso'
      } else {
        return 'Asignar municiones'
      }
    },
  },

  methods: {
    ...mapActions('municionCurso', ['saveMunicionCurso']),
    ...mapActions('movimientoMunicion', ['fetchMovimientoMunicion']),

    activeStepButtonHandler: async function () {
      if (this.activeStep < 3) {
        this.activeStep++
      } else {
        this.loading = true

        this.municionCurso.fechaAsignado = moment(this.municionCurso.fechaAsignado).format(this.API_DATE_FORMAT)
        await this.saveMunicionCurso(this.municionCurso)
        await this.fetchMovimientoMunicion()

        this.loading = false

        this.$router.go(-1)
      }
    },
  },
}
</script>

<style scoped>
/* Progreso circular */
::v-deep .v-progress-circular {
  transition: all 0.3s ease;
}

::v-deep .v-progress-circular__overlay {
  stroke: #6c5ce7 !important;
  filter: drop-shadow(0 0 8px rgba(108, 92, 231, 0.5));
}

/* Date picker */
::v-deep .v-date-picker-table {
  background: transparent !important;
}

::v-deep .v-date-picker-header {
  background: rgba(108, 92, 231, 0.1) !important;
}

::v-deep .v-btn--active {
  background: #6c5ce7 !important;
  color: #ffffff !important;
}

::v-deep .v-date-picker-table__current {
  border-color: #6c5ce7 !important;
}

/* Campos de entrada */
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  min-height: 48px !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .mdi-menu-down {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label {
  color: #a29bfe !important;
}

/* Enlaces */
a {
  color: #6c5ce7 !important;
  transition: all 0.3s ease;
}

a:hover {
  color: #a29bfe !important;
  text-decoration: underline !important;
}

/* Botones e iconos */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 92, 231, 0.3);
}

::v-deep .v-icon {
  color: #e0e0e0;
  transition: all 0.3s ease;
}

::v-deep .v-btn .v-icon {
  color: #ffffff !important;
}

.text-caption,
.text-subtitle-1,
.text-subtitle-2 {
  color: #e0e0e0 !important;
}

/* Transiciones */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* Asterisco rojo para campos requeridos */
.red--text {
  color: #ff5252 !important;
}

/* Date picker mejorado */
::v-deep .v-date-picker-header .v-btn {
  color: #a29bfe !important;
}

::v-deep .v-date-picker-table .v-btn {
  color: #e0e0e0 !important;
}

::v-deep .v-date-picker-table .v-btn:hover {
  background: rgba(108, 92, 231, 0.15) !important;
}

::v-deep .v-date-picker-table .v-btn--active {
  background: linear-gradient(135deg, #6c5ce7 0%, #a29bfe 100%) !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(108, 92, 231, 0.4);
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  padding: 8px 12px;
  font-size: 0.875rem;
  font-weight: 500;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(108, 92, 231, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(108, 92, 231, 0.6);
}
</style>
